"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExtraProtectionOutputWidget = void 0;
var React = require("react");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var InfoModal_1 = require("../../../components/modals/InfoModal");
var ExtraProtectionExplainedRenderers_1 = require("../../../components/modals/renderers/ExtraProtectionExplainedRenderers");
var ExtraProtectionOutputWidget = /** @class */ (function (_super) {
    __extends(ExtraProtectionOutputWidget, _super);
    function ExtraProtectionOutputWidget(props) {
        var _this = _super.call(this, props) || this;
        var vehicleIndexSetting = "vehicleIndex";
        _this.vehicleIndex = _this.getSetting(vehicleIndexSetting, undefined);
        if (_this.vehicleIndex) {
            if (isNaN(_this.vehicleIndex)) {
                throw Error("".concat(_this.props.question.type, " widget has incorrectly set '").concat(vehicleIndexSetting, "' setting: '").concat(vehicleIndexSetting, "' must be a number"));
            }
            else if (_this.vehicleIndex < 0) {
                throw Error("".concat(_this.props.question.type, " widget has incorrectly set '").concat(vehicleIndexSetting, "' setting: '").concat(vehicleIndexSetting, "' must be a non-negative integer"));
            }
        }
        _this.handleExtraProtectionChange = _this.handleExtraProtectionChange.bind(_this);
        return _this;
    }
    ExtraProtectionOutputWidget.prototype.render = function () {
        return (React.createElement("div", { className: this.getSetting("cssClass", ""), id: this.props.question.name },
            this.renderGuaranteedHireCarExtraPanel(),
            this.renderMotorLegalExpensesExtraPanel()));
    };
    ExtraProtectionOutputWidget.prototype.renderGuaranteedHireCarExtraPanel = function () {
        var courtesyCarAmount = this.props.interaction.vehicles[0].extraProtection.courtesyCarAmount; // is equal across vehicles
        return (React.createElement("div", { id: "courtesyCar", className: "small-panel p-4 mb-4 extraProtection-widget-optional-extras-panel-width ml-md-2 ".concat(this.handleBorderColor("courtesyCar") && "extraProtection-widget-radio-checked") },
            React.createElement("img", { className: "d-block mx-auto icon-medium", alt: "Car icon", src: "/img/Flow-guaranteed-hire-car.svg" }),
            React.createElement("h2", { className: "inner-content text-center muli-bold-16-black pt-3" }, "Guaranteed hire car"),
            React.createElement("p", { className: "text-center mb-3" },
                React.createElement("span", { className: "h3 font-weight-bold text-blue-1" }, "\u00A3".concat(courtesyCarAmount)),
                " /month"),
            React.createElement("div", { className: "d-flex" },
                React.createElement("p", { className: "font-weight-bold" }, "If your car is stolen or off the road following an accident would you need a hire car?"),
                React.createElement("div", { className: "pl-2 pr-3" },
                    React.createElement(InfoModal_1.InfoModal, { title: "Guaranteed hire car" }, (0, ExtraProtectionExplainedRenderers_1.renderCourtesyCarExplained)()))),
            this.renderAddExtraProtectionBtns("courtesyCar")));
    };
    ExtraProtectionOutputWidget.prototype.renderMotorLegalExpensesExtraPanel = function () {
        var legalProtectionAmount = this.props.interaction.vehicles[0].extraProtection.legalProtectionAmount; // is equal across vehicles
        return (React.createElement("div", { id: "legalProtection", className: "small-panel p-4 mb-4 extraProtection-widget-optional-extras-panel-width ml-md-2 ".concat(this.handleBorderColor("legalProtection") && "extraProtection-widget-radio-checked") },
            React.createElement("img", { className: "d-block mx-auto icon-medium", alt: "Legal document icon", src: "/img/Flow-legal-expenses.svg" }),
            React.createElement("h2", { className: "inner-content text-center muli-bold-16-black pt-3" }, "Motor legal expenses"),
            React.createElement("p", { className: "text-center mb-3" },
                React.createElement("span", { className: "h3 font-weight-bold text-blue-1" }, "\u00A3".concat(legalProtectionAmount)),
                " /month"),
            React.createElement("div", { className: "d-flex" },
                React.createElement("p", { className: "font-weight-bold" }, "Would you need help to cover the costs of legal action if you had an accident?"),
                React.createElement("div", { className: "pl-2 pr-3" },
                    React.createElement(InfoModal_1.InfoModal, { title: "Motor legal expenses" }, (0, ExtraProtectionExplainedRenderers_1.renderLegalProtectionExplained)()))),
            this.renderAddExtraProtectionBtns("legalProtection")));
    };
    ExtraProtectionOutputWidget.prototype.renderAddExtraProtectionBtns = function (extraProtectionName) {
        var _this = this;
        var vehicles = this.props.engine.getInteraction().vehicles;
        var btns = [];
        if (vehicles.length === 1) {
            var vehicle = vehicles[this.vehicleIndex];
            if (vehicle) {
                btns.push(this.renderAddExtraProtectionButton(extraProtectionName, vehicle, this.vehicleIndex));
            }
        }
        else {
            vehicles.forEach(function (vehicle, index) {
                btns.push(_this.renderAddExtraProtectionCheckBoxes(extraProtectionName, vehicle, index));
            });
        }
        return (React.createElement("div", { className: "falcon-checkbox form-group mt-0" }, btns));
    };
    ExtraProtectionOutputWidget.prototype.renderAddExtraProtectionButton = function (extraProtectionName, vehicle, index) {
        var checkboxId = extraProtectionName + index;
        return (React.createElement("div", { key: index, className: "checkbox-button text-center" },
            React.createElement("input", { className: "d-none w-100", id: checkboxId, type: "checkbox", "data-extra-protection-name": extraProtectionName, "data-vehicle-index": index, name: extraProtectionName, checked: vehicle.extraProtection[extraProtectionName], onChange: this.handleExtraProtectionChange }),
            React.createElement("label", { className: "cursor-pointer text-blue-1", htmlFor: checkboxId }, vehicle.extraProtection[extraProtectionName] ? "Remove" : "Yes, please")));
    };
    ExtraProtectionOutputWidget.prototype.renderAddExtraProtectionCheckBoxes = function (extraProtectionName, vehicle, index) {
        var checkboxId = extraProtectionName + index;
        return (React.createElement("div", { key: index, className: "d-flex" },
            React.createElement("div", { className: "form-check mr-3" },
                React.createElement("input", { className: "custom-control-input", id: checkboxId, type: "checkbox", "data-extra-protection-name": extraProtectionName, "data-vehicle-index": index, onChange: this.handleExtraProtectionChange, checked: vehicle.extraProtection[extraProtectionName] }),
                React.createElement("label", { className: "custom-control-label", htmlFor: checkboxId },
                    React.createElement("div", { className: "checkbox-big" }))),
            React.createElement("p", null, "".concat(vehicle.make, ", ").concat(vehicle.model, " (").concat(vehicle.registrationNumber, ")"))));
    };
    ExtraProtectionOutputWidget.prototype.handleExtraProtectionChange = function (event) {
        var vehicleIndex = event.target.dataset.vehicleIndex;
        var extraProtectionName = event.target.dataset.extraProtectionName;
        this.props.onStateChange("vehicles[".concat(vehicleIndex, "].extraProtection[").concat(extraProtectionName, "]"), event.target.checked);
        this.executeEvent("change");
        this.handleBorderColor(extraProtectionName);
    };
    ExtraProtectionOutputWidget.prototype.handleBorderColor = function (extraProtectionName) {
        var vehicles = this.props.interaction.vehicles;
        return vehicles.some(function (vehicle) { return vehicle.extraProtection[extraProtectionName] === true; });
    };
    return ExtraProtectionOutputWidget;
}(plugin_journey_1.WidgetBase));
exports.ExtraProtectionOutputWidget = ExtraProtectionOutputWidget;
//# sourceMappingURL=ExtraProtectionOutputWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/subscription/motor/ExtraProtectionOutputWidget.js
// module id = 3164
// module chunks = 0